<app-base-layout [showFooter]="false" [darkMode]="true">
  <div>
    <div class="application-confirmed-page-content">
      <h1 [innerHTML]="messageTitle | safeHtml"></h1>
      <div [innerHTML]="messageBody | safeHtml"></div>
      <!-- <div [innerHTML]="messageFooter | safeHtml"></div> -->
    </div>
    <app-rounded-button 
      *ngIf="envConfig.btnAppRedirect" 
      (click)="appRedirect()" 
      class="confirmed-page-button" 
      [isConfirmedPage]="true"
      >
      Abrir o APP
    </app-rounded-button>
  </div>
</app-base-layout>